module.exports = __webpack_public_path__ + "media/images/evolve-d4a9ec4a.png";